import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Theme } from '../models/theme.model';
import { RequestService } from './request.service';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  config: Theme = {
    theme: 'saga-blue',
    dark: false,
    inputStyle: 'outlined',
    ripple: true,
    direction: 'ltr',
  };
  constructor(private restApi: RequestService, private http: HttpClient) {}

  private configUpdate = new Subject<Theme>();
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Cache-Control':
        'no-cache, no-store, must-revalidate, post- check=0, pre-check=0',
      Pragma: 'no-cache',
      Expires: '0',
    }),
  };
  configUpdate$ = this.configUpdate.asObservable();

  updateConfig(config: Theme): void {
    this.config = config;
    this.configUpdate.next(config);
  }

  getConfig(): Theme {
    return this.config;
  }
  addProfile(profile) {
    return this.http.post(
      environment.apiUrl + '/api/v5/user-profiles',
      profile,
      this.httpOptions
    );
  }
  // updateProfile(id,profile){
  //   return this.http.put(environment.apiUrl+'/api/v5/user-profiles', profile, this.httpOptions);

  // }
  // getProfile(id){
  //   return this.http.get(environment.apiUrl+'/api/v5/user-profiles/'+id, this.httpOptions);
  // }
}
